import { render, staticRenderFns } from "./chart-panel.vue?vue&type=template&id=05156a92&scoped=true"
import script from "./chart-panel.vue?vue&type=script&lang=js"
export * from "./chart-panel.vue?vue&type=script&lang=js"
import style0 from "./chart-panel.vue?vue&type=style&index=0&id=05156a92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05156a92",
  null
  
)

export default component.exports